import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from "react-error-boundary";
import { initFirebaseAnalytics } from '@/lib/firebase'

import App from './App.tsx';
import { BrowserRouter } from 'react-router-dom';
import { ErrorFallback } from './ErrorFallback.tsx'

import "./main.css"
import "./styles/theme.css"
import "./index.css"

void initFirebaseAnalytics()

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <BrowserRouter><App /></BrowserRouter>
   </ErrorBoundary>
)
